import { createRouter } from "@tanstack/react-router";
import { approvalsRoute } from "./features/approvals/routes";
import { chatRoute } from "./features/chat/routes";
import { dashboardRoute } from "./features/dashboard/routes";
import { inboxRoute } from "./features/inbox/routes";
import { meetingNotesRoute } from "./features/meet/routes";
import {
  accountsSettingsRoute,
  notificationsSettingsRoute,
  profileSettingsRoute,
  sendersSettingsRoute,
  workspaceSettingsRoute,
  workspacesSettingsRoute,
} from "./features/settings/routes";
import { rulesSettingsRoute } from "./features/settings/rules/routes";
import { activitySettingsRoute, securitySettingsRoute } from "./features/settings/security/routes";
import { appRoute, indexRoute, rootRoute, workspaceRoute } from "./features/shell/routes";
import { tasksRoute } from "./features/tasks/routes";

/** Assembles the route tree; each feature owns its routes in `features/<feature>/routes.tsx`. */
const routeTree = rootRoute.addChildren([
  appRoute.addChildren([
    indexRoute,
    profileSettingsRoute,
    workspacesSettingsRoute,
    workspaceSettingsRoute,
    notificationsSettingsRoute,
    sendersSettingsRoute,
    securitySettingsRoute,
    activitySettingsRoute,
    rulesSettingsRoute,
    approvalsRoute,
    accountsSettingsRoute,
    workspaceRoute.addChildren([inboxRoute, tasksRoute, chatRoute, dashboardRoute, meetingNotesRoute]),
  ]),
]);

export function createAppRouter() {
  return createRouter({ routeTree, defaultPreload: "intent" });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
